'use strict';

var Reflux = require('reflux');

var Actions = Reflux.createActions([
    'setTopButtonVisible',
]);

var Store = Reflux.createStore({
    listenables: [ Actions ],

    getInitialState: function() {
        return false;
    },
    onSetTopButtonVisible: function(visibility) {
        this.trigger(visibility);
    },
});

module.exports = {
    Actions: Actions,
    Store: Store,
};



// WEBPACK FOOTER //
// ./src/events/events.jsx